<template>
      <div no-body class="lku-coa"> 
      <b-row>
        <b-col lg="7">
            <b-input-group>
              <b-input-group-prepend><label>Filter</label></b-input-group-prepend>
              <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
        <b-table
          class="mb-0"
          ref="tblCoa"
          responsive
          striped hover
          :items="items"
          :fields="fields"
          :current-page="tblData.page"
          :per-page="20"
          :filter="filter"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit" 
          @row-clicked="selectItem"
        >
        <template v-slot:cell(nomor)="data">
          {{ (tblData.page - 1) * tblData.limit + (data.index + 1)}}
        </template>
        </b-table>
        <b-row>
          <b-col cols="6">{{showingLabel}}</b-col>
          <b-col cols="6">
            <b-pagination
              align="right"
              :total-rows="tblData.total"
              :per-page="20"
              v-model="tblData.page"
            ></b-pagination>
          </b-col>
        </b-row>
      </div>
</template>
<style lang="scss">
  .lku-coa {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import crud from "../../apis/crud";
import toastr from "mini-toastr";
toastr.init();

export default {
  data() {
    return {
      fields: [
          {
            key: "nomor",
            thStyle: "width:50px",
            label: "No.",
          },
          {
            key: "kodegroup",
            label: "Group Code",
          },
          {
            key: "namagroup",
            label: "Group Name",
          },
      ],
      items:[],
      tblData: {
        tablename:'itemgroup',
        page: 1,
        total: 0,
        limit:1000,
        sortBy: 'kodegroup',
        sortDesc: false
      },
      filter:null
    };
  },
  computed: {
    showingLabel() {
      const { tblData } = this;
      const { page, total } = tblData;
      const limit=20;

      const val1 = (page - 1) * limit + 1;
      const val2 = page * limit < total ? page * limit : total;
      return `Showing ${val1} to ${val2} of ${total} entries`;
    },
  },
  created: async function() {
      this.data();
  },
  mounted() {
    // Set the initial number of items
    this.tblData.total = this.items.length;
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
      this.tblData.page = 1;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.items=await crud.list(this.tblData);
      return this.items;      

    },
    selectItem(item,index) {
        const idxChg = this.items.findIndex((rec)=>{
                        return (rec.kodegroup.startsWith(item.kodegroup) && (rec.kodegroup !==item.kodegroup));
                    })
        if ((idxChg || -1) > -1) {
          console.log ('Account punya anak tidak boleh dipilih');
            toastr.warn('Account punya anak tidak boleh dipilih!');
        } else {
        this.$emit("click", item);
        }
    },  
    refresh() {
      this.$refs.tblCoa.refresh();
    }
  }
};
</script>
